import { render, staticRenderFns } from "./tenderContact.vue?vue&type=template&id=2a1dab2d"
import script from "./tenderContact.vue?vue&type=script&lang=js"
export * from "./tenderContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports